import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "antd";

const MembersLicences = ({ data }) => {
  const { t } = useTranslation();
  const mainProduct = useMemo(() => {
    return data?.purchase_products?.find((prod) => prod.product_id === data?.main_product && prod?.type === "main");
  }, [data?.purchase_products, data?.main_product]);

  //console.log("mainProduct", mainProduct);
  // Check if main product format is "course-licences", else return null
  if (mainProduct?.format !== "course-licences") {
    return null;
  }

  // Check if price_option has "members_licences" defined and greater than zero
  const membersLicences = data?.price_option?.members_licences;
  if (!membersLicences || membersLicences <= 0) {
    return null;
  }

  return (
    <Card size="small" className="card-members-licences">
      <div className="text-center">
        <strong>{t("membersLicences.licencesCount", { count: membersLicences })}</strong>
      </div>
    </Card>
  );
};

export default MembersLicences;
